import styled from 'styled-components'
import {
  anatomyV2ContentWrapperCss,
  anatomyV2RootCss,
} from '~/pages/anatomyV2/libs/pageLayoutStyles'
import { COLORS } from '~/shared/constants/uiConstants'

export const TrueFalseQuestionTemplateStyles = {
  Root: styled.div`
    ${anatomyV2RootCss}
    overflow: hidden;
  `,

  ContentWrapper: styled.div`
    ${anatomyV2ContentWrapperCss}
    min-height: 0;
    padding: 16px;
    overflow-y: auto;
  `,

  Title: styled.h1`
    font-size: 22px;
    font-weight: 700;
    line-height: 1.1;
    color: ${COLORS.BLACK};
    margin: 24px 0;
  `,

  CardWrapper: styled.div<{
    $firstBehindColor?: string
    $secondBehindColor?: string
  }>`
    position: relative;
    margin-bottom: 24px;

    &::before {
      content: '';
      position: absolute;
      bottom: -20px;
      left: 50%;
      transform: translateX(-50%);
      width: 90%;
      height: 40px;
      background: ${({ $secondBehindColor }) =>
        $secondBehindColor ?? '#ffd387'};
      border: 1px solid #e3dcfb;
      border-radius: 12px;
      z-index: 0;
    }

    &::after {
      content: '';
      position: absolute;
      bottom: -12px;
      left: 50%;
      transform: translateX(-50%);
      width: 95%;
      height: 40px;
      background: ${({ $firstBehindColor }) =>
        $firstBehindColor ?? COLORS.PURPLE_100};
      border: 1px solid #e3dcfb;
      border-radius: 12px;
      z-index: 1;
    }
  `,

  Card: styled.div<{ $background?: string }>`
    position: relative;
    min-height: 343px;
    display: flex;
    flex-direction: column;
    background: ${({ $background }) => $background ?? COLORS.WHITE};
    border-radius: 12px;
    box-shadow: 0 4px 10px 0 rgba(62, 11, 143, 0.1);
    overflow: hidden;
    z-index: 2;
    text-align: center;
    padding: 12px 12px 16px;
  `,

  CardImage: styled.div`
    width: 100%;

    img {
      width: 100%;
      display: block;
    }
  `,

  CardFact: styled.p`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 16px;
    color: #000;
    text-align: center;
    font-family: 'Mulish', sans-serif;
    font-size: 20px;
    font-weight: 700;
    line-height: 1.2;
  `,

  AnswerRow: styled.div`
    display: flex;
    gap: 12px;
    margin-top: auto;
  `,

  AnswerButton: styled.button`
    flex: 1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    min-height: 48px;
    padding: 10px 16px;
    background: ${COLORS.WHITE};
    border: 1px solid ${COLORS.GRAY_400};
    border-radius: 8px;
    font-size: 14px;
    font-weight: 700;
    color: ${COLORS.BLACK};
    cursor: pointer;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
    touch-action: manipulation;

    &:active {
      background: ${COLORS.WHITE};
    }
  `,

  AnswerIcon: styled.img`
    width: 20px;
    height: 20px;
  `,
}
